export const COMPETITION_TYPES = [
  "DreamCarWinner",
  "CashCompetitionWinner",
  "midweekWinner",
  "SuperDrivesWinner",
  "SpecialCompetitionWinner",
  "easyWinCompetitionWinner",
  "SmallLifestyleCompetitionWinner",
];

export const COMPETITION_TYPE_DEFAULT_IMAGE = {
  DreamCarWinner: "winner-placeholder.jpg",
  CashCompetitionWinner: "winner-placeholder-lifestyle.jpg",
  midweekWinner: "winner-placeholder-midweek.jpg",
  SuperDrivesWinner: "winner-placeholder-superdrives.jpg",
  SpecialCompetitionWinner: "winner-placeholder-friday-fun.jpg",
  easyWinCompetitionWinner: "winner-placeholder-easy-win.jpg",
  SmallLifestyleCompetitionWinner: "winner-placeholder-small-lifestyle.jpg",
};

export const MAX_YEARS = 20;

export const WINNERS_PER_PAGE = 20;
